import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { ROUTE_OPTIMIZER_MODE } from './OptimizerWizard/types'

export function OptimizedBanner({ setShowingOptimizerWizard, setOptimizerMode }) {
  const onReviewResults = () => {
    setOptimizerMode(ROUTE_OPTIMIZER_MODE.USER_REVIEW)
    setShowingOptimizerWizard(true)
  }
  return (
    <Horizontal
      verticalCenter
      justifyContent='space-between'
      className='full-height-width py-2 px-3'
      border='all'
      bg='primary'
    >
      <Texto category='h5' weight='bold' appearance='primary'>
        Optimization run is pending review.
      </Texto>
      <GraviButton theme2 buttonText='Review Results' onClick={onReviewResults} />
    </Horizontal>
  )
}
